import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from 'angular';
import {Endpoints} from "../../shared/config/constant.module";
import HttpServiceName, {HttpService} from "../http/http.service";

export interface ShopService {
  getShops(): angular.IPromise<apsViewModels.ShopItem[]>;
  getPlants(): angular.IPromise<apsViewModels.PlantItem[]>;
  updateShop(shop: apsViewModels.ShopItem): angular.IPromise<any>;
  getShopConfiguration(shopId: string, time?: Date): angular.IPromise<apsViewModels.ShopConfigurationWithShifts>;
}

class ShopSvc implements ShopService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  getShops(): angular.IPromise<apsViewModels.ShopItem[]> {
    return this.httpService.get<apsViewModels.ShopItem[]>(Endpoints.SHOP);
  }

  getPlants(): angular.IPromise<apsViewModels.PlantItem[]> {
    return this.httpService.get<apsViewModels.PlantItem[]>(Endpoints.PLANT_LISTS);
  }

  updateShop(shop: apsViewModels.ShopItem): angular.IPromise<any> {
    return this.httpService.post(Endpoints.SHOP, shop);
  }

  getShopConfiguration(shopId: string, time?: Date): angular.IPromise<apsViewModels.ShopConfigurationWithShifts> {
    return this.httpService.get(Endpoints.SHOP_CONFIGURATION, {
      shopId: shopId,
      time: time
    });
  }
}

export default angular
  .module('aps.services.shops', [HttpServiceName])
  .service('shopService', ShopSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/shops/shops.service.ts